
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageTitle } from "@/components/PageTitle";
import { CTASection } from "@/components/CTASection";
import { ServiceTestimonials } from "@/components/ServiceTestimonials";
import { ServiceOverviewSection } from "@/components/services/ServiceOverviewSection";
import { ServiceFAQSection } from "@/components/services/ServiceFAQSection";
import { TreatmentServicesSection } from "@/components/services/TreatmentServicesSection";
import { RelatedServicesSection } from "@/components/services/RelatedServicesSection";
import { HeroServiceSection } from "@/components/services/HeroServiceSection";
import { WisdomToothHero } from "./WisdomToothHero";
import { WisdomToothOverview } from "./WisdomToothOverview";
import { WisdomToothServices } from "./WisdomToothServices";
import { WisdomToothTestimonials } from "./WisdomToothTestimonials";
import { WisdomToothFAQ } from "./WisdomToothFAQ";
import { WisdomToothRelated } from "./WisdomToothRelated";
import { WisdomToothCTA } from "./WisdomToothCTA";

const WisdomToothPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <PageTitle title="Wisdom Tooth Removal in Nagpur | Cost of Wisdom Tooth Removal in Nagpur" />
      <Header />
      
      <WisdomToothHero />
      <WisdomToothOverview />
      <WisdomToothServices />
      <WisdomToothTestimonials />
      <WisdomToothFAQ />
      <WisdomToothRelated />
      <WisdomToothCTA />
      
      <Footer />
    </div>
  );
};

export default WisdomToothPage;
